'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventsComponent = undefined;

var _event = require('./event.routes');

var _event2 = _interopRequireDefault(_event);

var _form = require('./form');

var _form2 = _interopRequireDefault(_form);

var _list = require('./list');

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = require('angular');

var uiRouter = require('angular-ui-router');

var EventsComponent =
/*@ngInject*/
exports.EventsComponent = function EventsComponent() {
  _classCallCheck(this, EventsComponent);

  this.message = 'Hello';
};

exports.default = angular.module('fiapiApp.events', [uiRouter, _form2.default, _list2.default]).config(_event2.default).component('event', {
  template: require('./event.pug'),
  controller: EventsComponent,
  controllerAs: 'eventsCtrl'
}).name;


// WEBPACK FOOTER //
// ./client/app/events/event.component.js